import { render, staticRenderFns } from "./prohibited.vue?vue&type=template&id=33cf7006"
import script from "./prohibited.vue?vue&type=script&lang=js"
export * from "./prohibited.vue?vue&type=script&lang=js"
import style0 from "./prohibited.vue?vue&type=style&index=0&id=33cf7006&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports